import React, { useState, useEffect } from 'react'
import {
  ButtonGroup,
  Col,
  Icon,
  IconButton,
  Input,
  InputGroup,
  Panel,
  Popover,
  Row,
  SelectPicker,
  Table,
  Tooltip,
  Whisper,
} from 'rsuite'
import { useForm, Controller, useFieldArray } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { v4 as uuidv4 } from 'uuid'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import TooltipButton from '../../components/buttons/TooltipButton'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import { doneLoading, startLoading } from '../../utils/loading'
import { copyAssessmentConfig, deleteAssessmentConfig } from '../../redux/actions/assessment'
import {
  DEFAULT_ERR_MSG,
  DELETE_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
  SUCCESS_MSG,
} from '../../constants/msgText'

export default function AddEvaluationPageWidget(props) {
  const history = useHistory()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isShowConfirmCopy, setIsShowConfirmCopy] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [deleteOrCopyId, setDeleteOrCopyId] = useState()

  const { Column, HeaderCell, Cell } = Table

  const handleOnConfirmDelete = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await deleteAssessmentConfig(deleteOrCopyId)
      if (response) {
        setFormSchema(response)
        setDeleteOrCopyId()
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    setIsShowConfirmDelete(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleOnConfirmCopy = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await copyAssessmentConfig(deleteOrCopyId)
      if (response) {
        setFormSchema(response)
        setDeleteOrCopyId()

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    setIsShowConfirmCopy(false)
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {formSchema?.form?.assessmentType && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={formSchema?.form?.assessmentType?.header || 'หมวดหมู่แบบประเมิน'}
          bordered
        >
          {/* <Row style={{ textAlign: 'end' }}>
            <SaveButton
              icon="plus"
              onClick={() => {
                history.push({
                  pathname: pathname.assessment.assessmentSettingType,
                })
              }}
              style={{ marginRight: 10, marginBottom: 10 }}
            >
              เพิ่มรายการ
            </SaveButton>
            <br />
          </Row> */}

          <Table
            autoHeight
            rowHeight={65}
            data={formSchema?.form?.assessmentType?.value || []}
            affixHeader
          >
            <Column width={80} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column minWidth={300} flexGrow={1}>
              <HeaderCell>ประเภทแบบประเมิน</HeaderCell>
              <Cell dataKey="assessmentTypeLabel" />
            </Column>
            <Column width={210}>
              <HeaderCell>วันที่แก้ไข</HeaderCell>
              <Cell dataKey="updateDate" />
            </Column>

            <Column width={150}>
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <Whisper placement="top" speaker={<Popover>แก้ไข</Popover>}>
                        <IconButton
                          onClick={() => {
                            history.push({
                              pathname: pathname.assessment.assessmentSettingType,
                              search: rowData.assessmentType || 0,
                            })
                          }}
                          className="rs-btn-edit"
                          appearance="ghost"
                          icon={<Icon icon="edit" />}
                          style={{ marginRight: 5 }}
                        ></IconButton>
                      </Whisper>
                      {/* <IconButton
                        onClick={() => {
                          setIsShowConfirmDelete(true)
                        }}
                        className="rs-btn-cancel"
                        appearance="ghost"
                        icon={<Icon icon="trash-o" />}
                        //style={{ marginRight: 10 }}
                      ></IconButton> */}
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Panel>
      )}

      <br />

      {formSchema?.form?.assessmentForm && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={formSchema?.form?.assessmentForm?.header || 'หัวข้อแบบประเมิน'}
          bordered
        >
          <Row style={{ textAlign: 'end' }}>
            <SaveButton
              icon="plus"
              onClick={() => {
                sessionStorage.setItem('assessmentId', '')
                history.push({
                  pathname: pathname.assessment.assessmentSettingAddForm,
                })
              }}
              style={{ marginRight: 10, marginBottom: 10 }}
            >
              เพิ่มรายการ
            </SaveButton>
            <br />
          </Row>
          <Table autoHeight wordWrap data={formSchema?.form?.assessmentForm?.value || []}>
            <Column width={70} align="center" fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column width={220} flexGrow={1} minWidth={200}>
              <HeaderCell>ชื่อแบบประเมิน</HeaderCell>
              <Cell dataKey="name" />
            </Column>
            <Column width={220}>
              <HeaderCell>ประเภทแบบประเมิน</HeaderCell>
              <Cell dataKey="categoryTypeLabel" />
            </Column>
            <Column width={100}>
              <HeaderCell>สถานะ</HeaderCell>
              <Cell dataKey="statusLabel" />
            </Column>
            {/* <Column width={150}>
              <HeaderCell>จำนวนหมวดหมู่</HeaderCell>
              <Cell dataKey="totalCategory" align="right" />
            </Column>
            <Column width={130}>
              <HeaderCell>จำนวนคำถาม</HeaderCell>
              <Cell dataKey="totalQuestion" align="right" />
            </Column> */}

            <Column width={200} align="right">
              <HeaderCell>งบประมาณเริ่มต้น</HeaderCell>
              {/* <Cell dataKey="budgetStart" /> */}
              <Cell>
                {(rowData) => {
                  return <span>{budgetFormat(rowData.budgetStart)}</span>
                }}
              </Cell>
            </Column>

            <Column width={200} align="right">
              <HeaderCell>งบประมาณสิ้นสุด</HeaderCell>
              <Cell>
                {(rowData) => {
                  return <span>{budgetFormat(rowData.budgetEnd)}</span>
                }}
              </Cell>
            </Column>

            <Column width={200} align="center">
              <HeaderCell>วันที่เริ่มต้น</HeaderCell>
              <Cell dataKey="startDate" />
            </Column>

            <Column width={200} align="center">
              <HeaderCell>วันที่สิ้นสุด</HeaderCell>
              <Cell dataKey="endDate" />
            </Column>

            <Column width={200} fixed="right">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <Whisper placement="top" speaker={<Popover>ดูตัวอย่าง</Popover>}>
                        <IconButton
                          onClick={() => {
                            var redirectPath = ''
                            if ([5, 6].includes(rowData.categoryType)) {
                              // history.push(
                              //   `${pathname.assessment.assessmentPrePostTestPreview}?assId=${rowData.id}`
                              // )
                              redirectPath = `${pathname.assessment.assessmentPrePostTestPreview}?assId=${rowData.id}`
                            } else if (3 == rowData.categoryType) {
                              redirectPath = `${pathname.assessment.assessmentMAndESelfForm}?assId=${rowData.id}&preview=1`
                            } else if (4 == rowData.categoryType) {
                              redirectPath = `${pathname.assessment.assessmentMAndEForm}?assId=${rowData.id}&preview=1`
                            } else {
                              sessionStorage.setItem('assessmentId', rowData.id)

                              redirectPath = pathname.assessment.assessmentSettingForm
                              // history.push({
                              //   pathname: pathname.assessment.assessmentSettingForm,
                              // })
                            }

                            history.push(`${redirectPath}`)
                          }}
                          className="rs-btn-save"
                          appearance="ghost"
                          icon={<Icon icon="eye" />}
                          style={{ marginRight: 5 }}
                        ></IconButton>
                      </Whisper>

                      <Whisper placement="top" speaker={<Popover>แก้ไข</Popover>}>
                        <IconButton
                          onClick={() => {
                            sessionStorage.setItem('assessmentId', rowData.id)
                            history.push({
                              pathname: pathname.assessment.assessmentSettingAddForm,
                            })
                          }}
                          className="rs-btn-edit"
                          appearance="ghost"
                          icon={<Icon icon="edit" />}
                          style={{ marginRight: 5 }}
                        ></IconButton>
                      </Whisper>

                      <Whisper placement="top" speaker={<Popover>ทำสำเนาใหม่</Popover>}>
                        <IconButton
                          onClick={() => {
                            setDeleteOrCopyId(rowData.id)
                            setIsShowConfirmCopy(true)
                          }}
                          className="rs-btn-save"
                          appearance="ghost"
                          icon={<Icon icon="copy-o" />}
                          style={{ marginRight: 5 }}
                        ></IconButton>
                      </Whisper>

                      <Whisper placement="top" speaker={<Popover>ลบ</Popover>}>
                        <IconButton
                          onClick={() => {
                            setDeleteOrCopyId(rowData.id)
                            setIsShowConfirmDelete(true)
                          }}
                          className="rs-btn-cancel"
                          appearance="ghost"
                          icon={<Icon icon="trash-o" />}
                          //style={{ marginRight: 10 }}
                        ></IconButton>
                      </Whisper>
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </Panel>
      )}

      <br />
      <br />
      <br />

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirmDelete}
        detail={`ยืนยันการลบรายการ `}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />

      <ConfirmWidget
        title={`ยืนยันการทำสำเนาใหม่`}
        show={isShowConfirmCopy}
        detail={`ยืนยันการทำสำเนาใหม่`}
        onCancle={() => setIsShowConfirmCopy(false)}
        onConfirm={handleOnConfirmCopy}
      />
    </>
  )
}
